import { Plugins } from '@capacitor/core'
import branchio from 'branchio-sdk'

import { appConfig } from './config'

const client = branchio({
  key: appConfig.branchKey,
})
const { BranchDeepLinks } = Plugins

export interface ILinkParams {
  analytics: {
    feature?: string
    [key: string]: unknown
  }
  properties: {
    $desktop_url: string
    refUsername?: string
  }
}

export async function generateDeepLink(params: ILinkParams) {
  // for android and ios natives
  if (BranchDeepLinks) {
    return BranchDeepLinks.generateShortUrl(params)
  }
  // web and android and ios web
  return await client.link({
    ...params.analytics,
    data: {
      ...params.properties,
    },
  })
}

export interface IBranchioMetadata {
  desktopUrl: string
  refUsername: string
}
